export default __webpack_public_path__ + "static/media/icon_collect_status_no_sign.53b9d6df.png";